export default {
  title: 'Explore by PONANT',
  pickers: {
    ships: 'Choisir un navire',
    regions: 'Choisir une zone',
    search: 'Trouver une escale',
    empty: 'Nous ne trouvons pas de correspondance parmi les escales de nos croisières. ',
    stopover: 'Escale',
  },
  cruising: 'En croisière',
  modal: {
    webcam: 'Voir la webcam',
    visit: 'Visiter le navire à 360°',
    showCruise: 'Voir sur la carte',
    more: 'En savoir plus',
    cruiseSeparator: 'La prochaine croisière',
    realTimeCheck: 'Suivez votre navire en temps réel',
    video: 'Découvrir le navire en vidéo',
  },
  ship: {
    more: 'En savoir plus sur {{name}}',
    allCruises: 'Voir toutes les croisières du navire',
    return: 'Retour sur la fiche du navire',
    nextCruise: 'La prochaine croisière',
    nextCruiseMulti: 'Les prochaines croisières',
  },
  stopover: {
    nextCruise: 'La prochaine croisière passant par ce lieu',
    nextCruiseMulti: 'Les prochaines croisières passant par ce lieu',
    allCruises: 'Voir toutes les croisières passant par ce lieu',
    panoramas: 'À découvrir aux alentours',
  },
  cruise: {
    quit: 'Quitter la croisière',
    from: 'Du',
    to: 'au',
    discover:
      'Découvrez les différentes étapes de la croisière et cliquez sur les escales pour en savoir plus sur chaque destination.',
    begin: 'Commencer',
    close: 'Quitter la croisière',
    noImage: 'Image non disponible',
  },
  close: 'Fermer',
  showMore: 'Lire la suite',
  regions: {
    alaska: 'Alaska',
    arctic: 'Arctique',
    northAmerica: 'Amérique du Nord & Canada',
    northEurope: 'Europe du Nord & Scandinavie',
    mediterranea: 'Méditerrannée',
    asia: 'Asie',
    redSea: 'Mer Rouge',
    caribbean: 'Caraïbes',
    centralAmerica: 'Amérique Centrale',
    southAmerica: 'Amérique du Sud',
    africa: 'Afrique & océan Indien',
    atlantic: 'Rivages atlantiques',
    oceania: 'Océanie & îles du Pacifique',
    antarctic: 'Antarctique',
  },
  branding: {
    body: "Profitez d'une expérience immersive et découvrez nos destinations comme si vous y étiez !",
    action: "Explorer l'univers Ponant",
  },
}
